import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import NativeOrWeb from '../../utils/native';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { checkVersion } from '../../store/version/api';
import { SlideTransition } from '../Transition/Transition';
import './VersionIncompatibleDialog.scss';
import { Browser } from '@capacitor/browser';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { toast } from 'react-toastify';
import IconToast from '../../components/NewToast';

const DialogStyle = {
  zIndex: 10000
};

const isNative = NativeOrWeb.isNativePlatform();
const platform = NativeOrWeb.getPlatform();

const VersionIncompatibleDialog = props => {
  const { intl } = props;

  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const onClickUpdate = async () => {
    if (platform === 'ios') {
      window.open('https://itunes.apple.com/hk/app/portfoplus/id1590830597?mt=8', '_blank');
    } else if (platform === 'android') {
      try {
        let result = await AppUpdate.getAppUpdateInfo();
        // toast.success(IconToast('info', JSON.stringify(result || {})), { className: 'new-toast' });
        if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE && result.immediateUpdateAllowed) {
          result = await AppUpdate.performImmediateUpdate();
        } else {
          window.open('https://play.google.com/store/apps/details?id=com.portfoplus.PortfoPlus', '_blank');
        }
      } catch (e) {
        toast.error(IconToast('error', JSON.stringify(e || {})), { className: 'new-toast' });
        window.open('https://play.google.com/store/apps/details?id=com.portfoplus.PortfoPlus', '_blank');
      }
    }
  };

  const onClickAndroidApk = () => {
    window.open('https://www.portfoplus.com/assets/apk/portfoplus.apk', '_blank');
  };

  const goToWeb = () => {
    Browser.open({ url: 'https://app.portfoplus.com/web/' });
  };

  useEffect(() => {
    if (isNative) {
      const check = async () => {
        const isCompatible = await checkVersion();
        setOpen(!isCompatible);
      };
      check()
        .then()
        .catch();
    }
  }, []);

  return isNative ? (
    <Dialog
      className="version-incompatible-dialog"
      open={open}
      fullWidth={true}
      style={DialogStyle}
      slots={{
        transition: SlideTransition
      }}
    >
      <DialogContent>
        <span>{intl.formatMessage({ id: 'version-incompatible-dialog-content' })}</span>
        {platform === 'android' && (
          <>
            <span>{' ' + intl.formatMessage({ id: 'download-android-apk-content' })}</span>
            <span
              onClick={onClickAndroidApk}
              style={{ color: theme.palette.primary.main, textDecoration: 'underline', cursor: 'pointer' }}
            >
              {intl.formatMessage({ id: 'android-apk' })}
            </span>
            <span>{intl.formatMessage({ id: '.' })}</span>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={goToWeb}>
          {intl.formatMessage({ id: 'web-version' })}
        </Button>
        <Button color="primary" variant="contained" onClick={onClickUpdate}>
          {intl.formatMessage({ id: 'Update' })}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

export default injectIntl(VersionIncompatibleDialog);
